import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthGuard } from '@/components/AuthGuard';
import { DashboardStudio } from '@/pages/DashboardStudio';
import { AssetClasses } from '@/pages/AssetClasses';
import { Contributions } from '@/pages/Contributions';
import { Login } from '@/pages/Login';
import { Signup } from '@/pages/Signup';
import { TargetPortfolio } from '@/pages/TargetPortfolio';
import { Settings } from '@/pages/Settings';
import { Market, MarketDetails } from '@/pages/Market';
import { Proventos } from '@/pages/Proventos';
import { FiiRadar } from '@/pages/FiiRadar';
import { StockRadar } from '@/pages/StockRadar';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route
          path="/dashboard"
          element={
            <AuthGuard>
              <DashboardStudio />
            </AuthGuard>
          }
        />
        <Route
          path="/contributions"
          element={
            <AuthGuard>
              <Contributions />
            </AuthGuard>
          }
        />
        <Route
          path="/asset-classes"
          element={
            <AuthGuard>
              <AssetClasses />
            </AuthGuard>
          }
        />
        <Route
          path="/target-portfolio"
          element={
            <AuthGuard>
              <TargetPortfolio />
            </AuthGuard>
          }
        />
        <Route
          path="/settings"
          element={
            <AuthGuard>
              <Settings />
            </AuthGuard>
          }
        />
        <Route
          path="/market"
          element={
            <AuthGuard>
              <Market />
            </AuthGuard>
          }
        />
        <Route
          path="/market/:ticker"
          element={
            <AuthGuard>
              <MarketDetails />
            </AuthGuard>
          }
        />
        <Route
          path="/proventos"
          element={
            <AuthGuard>
              <Proventos />
            </AuthGuard>
          }
        />
        <Route
          path="/fii-radar"
          element={
            <AuthGuard>
              <FiiRadar />
            </AuthGuard>
          }
        />
        <Route
          path="/stock-radar"
          element={
            <AuthGuard>
              <StockRadar />
            </AuthGuard>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
